module.exports = __webpack_public_path__ + "img/GBM1_Plasma.2f65db62.png";